    import React from "react";
import { Link, useLocation} from 'react-router-dom';

import trial from '../images/trial_banner.png'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'
import 'swiper/css';
import Button from "./Button";


function Banner({ img, mimg, img2, mimg2, alt, heading, heading2, subheading, subheading2, textposition, renderButton}) {
    const {pathname} = useLocation();
     const ScrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        })
    }
    return (
        <div>
            <Swiper
                slidesPerView={1}
                spaceBetween={0}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                modules={[Autoplay]}
            >
                <SwiperSlide>

                    {/* Desktop */}
                    <div className="relative ">
                        <img className="banner-image hidden md:block " src={img} alt={alt} />
                        
                        {/* Mobile Banner*/}
                        <img className="banner-image !h-[500px] !object-cover block md:hidden " src={mimg} alt={alt} />

                        <div className={`absolute text-black bg-white border-l-[6px] border-yellow opacity-80 space-y-[25px] p-6 sm:py-[45px] sm:px-[35px]  ${textposition}`}>
                            <h1 className="font-alibaba font-bold text-[30px] sm:text-[48px] sm:leading-[56px]">{heading}</h1>
                            <p className="font-alibaba max-w-[430px] sm:text-[20px] !mb-[40px]">{subheading}</p>

                            {renderButton && renderButton()}
        
                        </div>
                    </div>

                    {/* Mobile */}
                    <div className="relative z-0 hidden">
                        <img className="w-full h-[500px] object-cover" src={mimg} alt={alt} />

                        <div className={`absolute text-black bg-white border-l-[6px] border-yellow opacity-80 space-y-[25px] p-6 sm:py-[45px] sm:px-[35px] ${textposition}`}>
                            <h1 className="font-alibaba font-bold text-[30px] sm:text-[48px] sm:leading-[56px]">{heading}</h1>
                            <p className="font-alibaba max-w-[430px] sm:text-[20px] !mb-[40px]">{subheading}</p>


                        </div>
                    </div>
                </SwiperSlide>



                {/*                 
           <SwiperSlide>
            <div className="relative">
                <img className="banner-image overlay hidden md:block" src={img2} alt={alt} />
                <img className="banner-image overlay block md:hidden" src={mimg2} alt={alt} />


                    <div className=" absolute top-24 left-8 text-white  md:w-[677px] h-[171px] md:top-48 md:left-28">
                        <p className="text-[34px] leading-[32.98px] font-normal md:leading-[74.75px] md:text-[69px] md:tracking-[1.3px] font-[Lora]">{heading2}</p>
                        <p className="font-[Lato] text-[12px] md:text-[22px] mt-3 ml-2 mb-5 ">{subheading2}</p>
                        <button className="w-[100px] h-[30px] text-[10px] tracking-[1.8px] leading-3 md:w-[150px] md:h-[44px] bg-yellow text-button text-center font-[Worksans] md:text-[14px] font-medium md:leading-4 md:tracking-[1.4px] uppercase">Read More</button>

                    </div>
                
                </div> 
           </SwiperSlide> */}

            </Swiper>

        </div>
    )

}


export default Banner